import { StateMap } from './StateMap.type'
import { StateMapDisk } from './state_map_disk.enum'

export default function createDefaultStateMap(disk: StateMapDisk): StateMap {
  return {
    id: null,
    dname: null,
    bio: null,
    disk,
  }
}
